import { faLightbulb, faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import UseChaseProvider from '../utils/use-chase-provider'
import { chaseHelpTextData } from '../utils/data/chase-help-data'

const HelpCard: React.FC = () => {
    const [isOpened, setIsOpened] = useState<boolean>(true)
    const { chaseType } = UseChaseProvider()
    const chaseHelpText: any = chaseHelpTextData.find((chaseHelp) => chaseHelp.id === chaseType)

    return (
        <>
            {(isOpened && chaseHelpText?.helpText) && <div className='w-full p-4 sm:p-5 rounded-card bg-[rgba(245,165,36,0.07)] border border-[rgba(245,165,36,0.25)] animate-fade-in'>
                <div className='w-full flex items-center justify-between'>
                    <h2 className='flex items-center justify-start gap-2.5 text-titleSM text-white'>
                        <span className='w-8 h-8 rounded-[10px] bg-[rgba(245,165,36,0.15)] flex items-center justify-center'><FontAwesomeIcon icon={faLightbulb} className='text-warn text-[13px]' /></span>
                        Help Text
                    </h2>
                    <button type='button' aria-label='Close help text' onClick={() => setIsOpened(false)} className='w-9 h-9 -mr-1 rounded-full flex items-center justify-center text-white/[0.55] hover:text-white hover:bg-white/[0.08] transition-colors'>
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </div>

                <ul className='mt-3 space-y-2 pl-1'>
                    {
                        Object.keys(chaseHelpText?.helpText!).map((chaseHelpKey: any) => {
                            return (
                                <li key={chaseHelpKey} className="flex gap-2.5 text-[14px] leading-[21px] font-normal text-white/[0.66]">
                                    <span className='mt-[8px] min-w-[5px] h-[5px] rounded-full bg-warn' />
                                    <span><span className="font-bold text-white">{chaseHelpKey}:</span> {chaseHelpText.helpText[chaseHelpKey]}</span>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>}
        </>
    )
}

export default HelpCard
